import $ from 'jquery'

export function initAudio(el) {
  $(el).each((index, audio) => {
    setTimeout(() => { _initAudio(audio) }, 0)
  })
}

function _initAudio(audioEl) {
  const $audio = $(audioEl);
  const audioId = $audio[0].dataset.eventLabel;

  _audioEventsListners($audio, audioId);
  _impressionEvent(audioId);
}


function _audioEventsListners(el, id) {
  const $audio = $(el);
  let audioConditions = {
    wasFiftyReached: false,
    audioStarted: false,
    audioEnded: false
  };

  $audio.on('play', () => {
    if (!audioConditions.audioStarted) {
      audioConditions.audioStarted = true;
      _playEventHandler(id);
    }

    if (!audioConditions.wasFiftyReached) {
      // Starting counter for Triggering of 50% Event
      const percentCounter = setInterval(function() {
        var viewedPercentage = Math.round((($audio[0].currentTime / $audio[0].duration) * 100));

        if (viewedPercentage >= 50) {
          audioConditions.wasFiftyReached = true;
          _audioHalfListned(id);
          clearInterval(percentCounter);
        }
      }, 500);

      $audio.on('pause', () => {
        clearInterval(percentCounter);
      });
    }
  });

  $audio.on('ended', () => {
    if (!audioConditions.audioEnded) {
      audioConditions.audioEnded = true;
      _audioListenedFully(id);
    }
  })
}

function _impressionEvent(id) {
  _gaEvent('Audio-player', 'Impression', id);
  _snowplowEvent('Audio-player', 'Impression', id);
}

function _audioHalfListned(id) {
  _gaEvent('Audio-player', 'Listened-50', id);
  _snowplowEvent('Audio-player', 'Listened-50', id);
}

function _playEventHandler(id) {
  _gaEvent('Audio-player', 'Play', id);
  _snowplowEvent('Audio-player', 'Play', id);
}

function _audioListenedFully(id) {
  _gaEvent('Audio-player', 'Complete', id);
  _snowplowEvent('Audio-player', 'Complete', id);
}

function _gaEvent(category, action, label) {
  ga('send', 'event', category, action, label);
}

function _snowplowEvent(category, action, label) {
  snowplow('trackStructEvent', category, action, label);
}
